import { IAppConfig } from './IAppConfig';

const appConfig: IAppConfig = {
    delayOnProcessFailure: 10000
};

export default appConfig;
